import { useQuery } from "@tanstack/react-query";
import { get } from "../../../../../api/util";
import Spinner from "../../../../spinner/Spinner";
import IngenRegistreringer from "../../../person/id/IngenRegistreringer";
import { DisplayItem } from "../../../../formcontrols/DisplayItem";
import DefaultLoadingError from "../../../../error/DefaultLoadingError";
import { Kursushold } from "../../../../../interfaces/schema";
import { PrismatrixDTO } from "../../../../../interfaces/formDto";
import { differenceInCalendarDays } from "date-fns";

const KursusPrismatrix = (props: { kursushold: Kursushold }) => {
  const { kursushold } = props;
  const { data, isLoading, error, refetch } = useQuery<PrismatrixDTO[]>({
    queryKey: ["prismatrix"],
    queryFn: async function () {
      return get({
        query: "prismatrix",
      });
    },
  });

  if (isLoading) {
    return <Spinner size={32} />;
  }

  if (error) {
    return (
      <DefaultLoadingError
        label="Der skete en fejl ved indlæsning af data"
        refreshLabel="Indlæs igen"
        onRefresh={() => refetch()}
      />
    );
  }

  if (!data) {
    return (
      <div className="text-muted">
        Data fejl: Prismatrix data kunne ikke findes.
      </div>
    );
  }

  // const { kursushold } = apolloData;
  const date = parseInt(kursushold.fraDato.split("-")[0]);
  if (date < 2019) return <IngenRegistreringer />;
  const prissaet = data.find((e) => {
    const fraDato = new Date(e.periodeFraDato);
    const tilDatoInklusiv = new Date(e.periodeTilDatoInklusiv ?? "9999-12-31");
    const current = new Date();
    return (
      differenceInCalendarDays(current, fraDato) >= 0 &&
      differenceInCalendarDays(tilDatoInklusiv, current) >= 0
    );
  });
  const days =
    Math.ceil(
      (new Date(kursushold.tilDato).getTime() -
        new Date(kursushold.fraDato).getTime()) /
        (1000 * 3600 * 24),
    ) + 1;
  const dagspris = prissaet?.fmuKursusholdDagspris ?? 0;
  const overnatningspris = prissaet?.fmuKursusholdOvernatningspris ?? 0;
  const uOvernatning = dagspris * days;
  const mOvernating = dagspris * days + overnatningspris * (days - 1);
  const mOvernatingDagenFoer = (dagspris + overnatningspris) * days;

  return (
    <div className="d-flex gap-5 border-bottom border-top py-3 px-1">
      <div>
        <DisplayItem label="Dagspris" text={`${dagspris} kr`} />
      </div>
      <div>
        <DisplayItem label="Overnatningspris" text={`${overnatningspris} kr`} />
      </div>
      <div>
        <DisplayItem label="Uden overnatning" text={`${uOvernatning} kr`} />
      </div>
      <div>
        <DisplayItem label="Med overnatning" text={`${mOvernating} kr`} />
      </div>
      <div>
        <DisplayItem
          label="Med overnatning dagen før"
          text={`${mOvernatingDagenFoer} kr`}
        />
      </div>
    </div>
  );
};

export default KursusPrismatrix;
